/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailSignatureUpdateSignatureKind } from './emailSignatureUpdateSignatureKind';
import type { EmailSignatureUpdateTemplateKey } from './emailSignatureUpdateTemplateKey';
import type { SignatureTemplateConfig } from './signatureTemplateConfig';

/**
 * Patch the in-progress draft content (``draft_*`` columns).
 *
 * Empty / whitespace-only values are allowed — the editor PATCHes on
 * every debounced edit. The canonical ``body_html`` only changes when
 * the user calls ``POST .../publish``.
 */
export interface EmailSignatureUpdate {
  name?: string | null;
  body_html?: string | null;
  signature_kind?: EmailSignatureUpdateSignatureKind;
  template_key?: EmailSignatureUpdateTemplateKey;
  template_config?: SignatureTemplateConfig | null;
}
